import React, { useState, useEffect } from 'react';
import './ConsultForm.css';
import { useConsultForm, SubmitStatus } from '../../hooks/useConsultForm';
import Message, { MessageType } from '../Message/Message';

const ConsultForm: React.FC = () => {
  const {
    form,
    errors,
    submitStatus,
    submitMessage,
    handleChange,
    handleSubmit,
    resetForm,
  } = useConsultForm();

  const [showMessage, setShowMessage] = useState(false);

  // 当提交状态改变时显示消息
  useEffect(() => {
    if (submitStatus === SubmitStatus.SUCCESS || submitStatus === SubmitStatus.ERROR) {
      setShowMessage(true);
      
      // 成功时3秒后自动隐藏，失败时5秒后自动隐藏
      const timeout = submitStatus === SubmitStatus.SUCCESS ? 3000 : 5000;
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, timeout);

      return () => clearTimeout(timer);
    }
  }, [submitStatus]);

  // 获取提交按钮文本
  const getSubmitButtonText = () => {
    switch (submitStatus) {
      case SubmitStatus.LOADING:
        return '提交中...';
      case SubmitStatus.SUCCESS:
        return '提交成功';
      default:
        return '提交咨询';
    }
  };

  // 获取消息类型
  const getMessageType = () => {
    return submitStatus === SubmitStatus.SUCCESS ? MessageType.SUCCESS : MessageType.ERROR;
  };

  return (
    <div className="consult-bg">
      {/* 消息通知 */}
      <Message
        type={getMessageType()}
        message={submitMessage}
        visible={showMessage}
        onClose={() => setShowMessage(false)}
      />

      <form className="consult-form" onSubmit={handleSubmit}>
        <h2 className="consult-title">免费咨询</h2>
        <div className="consult-subtitle">我们将尽快与您取得联系</div>
        
        {/* 称呼字段 */}
        <div className="consult-group">
          <label>称呼 <span className="required">*</span></label>
          <input 
            name="name" 
            placeholder="请输入您的称呼" 
            value={form.name} 
            onChange={handleChange}
            maxLength={50}
            disabled={submitStatus === SubmitStatus.LOADING}
          />
          {errors.name && <div className="consult-error">{errors.name}</div>}
        </div>

        {/* 联系方式字段 */}
        <div className="consult-group">
          <label>联系方式（至少填写一项）</label>
          <div className="consult-contact-row">
            <input 
              name="phone" 
              placeholder="请输入手机号" 
              value={form.phone} 
              onChange={handleChange}
              maxLength={20}
              disabled={submitStatus === SubmitStatus.LOADING}
            />
            <input 
              name="email" 
              placeholder="请输入邮箱" 
              value={form.email} 
              onChange={handleChange}
              maxLength={100}
              disabled={submitStatus === SubmitStatus.LOADING}
            />
            <input 
              name="wechat" 
              placeholder="请输入微信号" 
              value={form.wechat} 
              onChange={handleChange}
              maxLength={50}
              disabled={submitStatus === SubmitStatus.LOADING}
            />
          </div>
          {errors.contact && <div className="consult-error">{errors.contact}</div>}
          {errors.phone && <div className="consult-error">{errors.phone}</div>}
          {errors.email && <div className="consult-error">{errors.email}</div>}
          {errors.wechat && <div className="consult-error">{errors.wechat}</div>}
        </div>

        {/* 公司名称字段 */}
        <div className="consult-group">
          <label>公司名称 <span className="required">*</span></label>
          <input 
            name="company" 
            placeholder="请输入公司名称" 
            value={form.company} 
            onChange={handleChange}
            maxLength={100}
            disabled={submitStatus === SubmitStatus.LOADING}
          />
          {errors.company && <div className="consult-error">{errors.company}</div>}
        </div>

        {/* 业务诉求字段 */}
        <div className="consult-group">
          <label>业务诉求</label>
          <textarea 
            name="demand" 
            placeholder="请描述您的具体需求（选填）" 
            value={form.demand} 
            onChange={handleChange}
            maxLength={1000}
            rows={4}
            disabled={submitStatus === SubmitStatus.LOADING}
          />
          <div className="consult-char-count">
            {form.demand.length}/1000
          </div>
          {errors.demand && <div className="consult-error">{errors.demand}</div>}
        </div>

        {/* 提交按钮 */}
        <button 
          className={`consult-submit ${submitStatus === SubmitStatus.LOADING ? 'consult-submit--loading' : ''} ${submitStatus === SubmitStatus.SUCCESS ? 'consult-submit--success' : ''}`}
          type="submit"
          disabled={submitStatus === SubmitStatus.LOADING}
        >
          {getSubmitButtonText()}
        </button>

        {/* 成功后的重置按钮 */}
        {submitStatus === SubmitStatus.SUCCESS && (
          <button 
            type="button" 
            className="consult-reset"
            onClick={resetForm}
          >
            再次提交
          </button>
        )}
      </form>
    </div>
  );
};

export default ConsultForm; 